'use client'

//___IMPORTS
import { useTranslations } from 'next-intl'
import { useParams } from 'next/navigation'
import React, { useEffect, useState } from 'react'
import { FaClock, FaMap, FaMapMarkerAlt, FaPhone } from 'react-icons/fa'

//__COMPONENTS
import { ButtonBooking } from '@/components/home/btn-book'

//__TYPES
import { Branch } from '../../types/schema'

//__STYLES
import '@/styles/components/_cityCardContainer.scss'

//__INTERFACES
interface CityCardContainerProps {
  branch: Branch
}

//__HELPER FUNCTIONS
const getCityViewMoreKey = (city: string | string[] | undefined): string => {
  if (typeof city !== 'string') return 'BTN_VIEWMORE'
  return `${city.charAt(0).toUpperCase() + city.slice(1)}.BTN_VIEWMORE`
}

export default function CityCardContainer({ branch }: CityCardContainerProps) {
  const { city } = useParams()
  const t = useTranslations()
  const [currentOrigin, setCurrentOrigin] = useState('')

  // Set current origin after component mounts
  useEffect(() => {
    setCurrentOrigin(window.location.origin)
  }, [])

  // URL normalization function that uses the state
  const normalizeUrl = (url: string) => {
    return currentOrigin ? url.replace(/https?:\/\/[^\/]+/, currentOrigin) : url
  }

  //__RENDER
  return (
    <div className='card--container'>
      <a href={normalizeUrl(branch.url)} className='cover-img'>
        <img src={branch.image} alt={`${branch.name} image`} rel='preload' />
      </a>
      <div className='card--container-content'>
        <a
          href={normalizeUrl(branch.url)}
          className='card--container-content-title branch--detail__link'>
          <h2>{branch.name}</h2>
        </a>
        <h4 className='card--container-content-subtitle'>{branch.short_desc}</h4>
        <h4 className='card--container-content-description'>{branch.medium_desc}</h4>
        <div className='branch--detail--container'>
          <a href={branch.map_link} target='_blank' className='branch--detail'>
            <FaMapMarkerAlt className='branch--detail__icon' />
            <span className='branch--detail__text branch--detail__link'>{branch.address}</span>
          </a>
          <div className='branch--detail'>
            <FaClock className='branch--detail__icon' />
            <span className='branch--detail__text branch--detail__link'>
              Open: {branch.open_timename} - {branch.close_timename}
            </span>
          </div>
          <a href={`tel:${branch.branch_phone}`} className='branch--detail'>
            <FaPhone className='branch--detail__icon' />
            <span className='branch--detail__text branch--detail__link'>
              RSVN (8:30-21:30 daily):{' '}
              <strong className='text-theme-orange'>{branch.branch_phone}</strong>
            </span>
          </a>
        </div>

        <div className='btn--container'>
          <div className='btn--container-start'>
            <a className='btn-view--map' href={branch.map_link} target='_blank'>
              <i className='mx-2 text-2xl'>
                <FaMap />
              </i>
              {t('Work US.WORK_MAP')}
            </a>

            <a href={normalizeUrl(branch.url)} className='btn-view--more'>
              {t(`${getCityViewMoreKey(city)}`)}
            </a>
          </div>
          <div className='btn--container-end'>
            <div className='card--button'>
              <ButtonBooking branchId={branch.id} allowChange={true} />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
